// extracted by mini-css-extract-plugin
module.exports = {"container":"container--2NZgr"};